import {CarbonEnvName, CarbonEnvs} from "../../src/constants/urls";
import {getRootUrlFromCarbonHost} from "../../src/utils/urls";
import {OgProps, ValidOgPath} from "./ogPathMap";

export const getOgImagePath = <T extends ValidOgPath>(
  path: T,
  props: OgProps<T>,
  host: (typeof CarbonEnvs)[CarbonEnvName],
): string => {
  const base = getRootUrlFromCarbonHost(host);
  const route = "/api/og";
  const query = new URLSearchParams({
    path: path,
    props: JSON.stringify(props),
  });
  return `${base}${route}?${query}`;
};
